import { thirdPartyConnectedDataSourceResource } from '@jira/router-resources__third-party-connected-data-source/src/index.tsx';
import { IssueViewSkeleton } from '@jira/issue__issue-view-skeleton/src/IssueViewSkeleton.tsx';
import { currentUserResource } from '@jira/router-resources__current-user/src/index.tsx';
import { ISSUE_VIEW } from '@atlassian/jira-capabilities/src/constants.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@atlassian/jira-common-constants/src/ssr-early-assets.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { issueViewRelayResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-agg-data/index.tsx';
import { issueGiraDataResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-gira-data/index.tsx';
import { getModernIssueTransitionResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { browseIssueEmbedRoute } from '@atlassian/jira-router-routes-issue-routes/src/browseIssueEmbedRoute.tsx';
import { workspaceResource } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/services/resources/index.tsx';
import { getAIContextPanelResources } from '@atlassian/jira-servicedesk-ai-context-panel-resources/src/services/index.tsx';
import { getDraftReplyPillsResource } from '@atlassian/jira-servicedesk-draft-reply-resources/src/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { projectGlobalComponentsResource } from '@atlassian/jira-router-resources-project-global-components/src/services/index.tsx';
import {
	getJsmIssueViewRelatedArticlesResource,
	getJsmIssueViewSlaPanelResource,
} from '@atlassian/jira-router-resources-jsm-issue-view/src/services/index.tsx';
import { issueCollapsibleGroupDataResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-collapsible-group-data/issue-collapsible-group-data-resource.tsx';
import { issueHideEmptyFieldsDataResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-hide-empty-fields-data/issue-hide-empty-fields-data-resource.tsx';
import { issueViewRemoteDataResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-view-remote-data/index.tsx';
import { issueSelectedTabDataResource } from '@atlassian/jira-router-resources-issue-view/src/services/issue-selected-tab-data/issue-selected-tab-data-resource.tsx';
import { LazyIssuePage, IssueEmbedComponent } from './ui/index.tsx';

export const browseIssueEmbedRouteEntry = createEntry(browseIssueEmbedRoute, () => ({
	isStrictModeEnabled: false,
	group: 'issue',
	preloadOptions: {
		earlyChunks: ['issue-app-early-entry'],
	},
	earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
	component: IssueEmbedComponent,
	skeleton: IssueViewSkeleton,
	layout: chromelessLayout,
	resources: [
		...getModernIssueTransitionResources(),
		issueGiraDataResource,
		issueViewRelayResource,
		workspaceResource,
		...jiraSpaResources(),
		...getAIContextPanelResources(),
		...getDraftReplyPillsResource(),
		resourceWithCondition2(
			() => fg('jira-project-isglobalcomponent-route-resource'),
			projectGlobalComponentsResource,
		),
		resourceWithCondition2(
			() => fg('magma-3869-jsm-issue-view-sla-panel-fixes'),
			getJsmIssueViewSlaPanelResource(),
		),
		resourceWithCondition2(
			() => fg('clefairy-12-move-knowledge-base-to-ssr'),
			getJsmIssueViewRelatedArticlesResource(),
		),
		resourceWithCondition2(
			() => fg('jfp-magma-ssr-issue-selected-tab'),
			issueSelectedTabDataResource,
		),
		resourceWithCondition2(
			() => fg('jfp-magma-ssr-iv-collapse-group'),
			issueCollapsibleGroupDataResource,
		),
		resourceWithCondition2(
			() => fg('ken-3458-jira-hide-empty-field-ssr-fix'),
			issueHideEmptyFieldsDataResource,
		),
		resourceWithCondition2(
			() => fg('jiv-21223_issue_view_remote_data_query_earlier'),
			issueViewRemoteDataResource,
		),
		resourceWithCondition2(
			() => fg('jira-issue-view-3p-attachments'), // additional FG that need 3P resources should use or condition
			thirdPartyConnectedDataSourceResource,
		),
		resourceWithCondition2(() => fg('jfp-magma-current-user-resource'), currentUserResource),
	],
	forPaint: [LazyIssuePage],
	ufoName: 'issue-view-embed',
	meta: {
		capability: ISSUE_VIEW,
	},
	bifrost: {
		bifrostGroup: 'issue-view',
		bundling: {
			packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueEmbedRouteEntry.tsx',
			whichExportToUse: 'browseIssueEmbedRouteEntry',
		},
		enabled: true,
		manifestName: 'jira-spa-issue-view.json',
	},

	supportsPreviewPanel: true,
	isHydrateRootEnabled: fg('jfp-magma-issue-view-embed-hydrate-root'),
}));
